const messages: Record<string, string> = {
	'loader.loading': 'Načítání dat …',
	'loader.error': 'Načítání dat se nezdařilo, opakujte pokus později …',
	'connectionError.title': 'Problém se spojením',
	'connectionError.description': 'Problém se spojením, prosím uložte fotografii znovu.',
	'mainError.tryAgain': 'Opakujte prosím pokus',
	'landing.headline.policyCheck': 'Vítejte!',
	'landing.paragraph': 'Jste pouze 2 kroky od dokončení prohlídky Vašeho vozu',
	'landing.stepDescription.fourDiagonalPerspectives': 'Pořiďte požadovanou fotodokumentaci',
	'landing.stepDescription.feedback': 'Ohodnoťte nás',
	'landing.termsAndConditionsLinkDescription':
		'Spuštěním aplikace souhlasíte s <tclink>podmínkami jejího použití</tclink>',
	'button.start': 'Začít',
	'button.close': 'Ukončit',
	'landing.aboutPolicyCheck': 'Zpět',
	'tutorialModal.headline.first.policyCheck': 'Co je prohlídka vozidla?',
	'tutorialModal.paragraph.first.policyCheck':
		'Prohlídku vozidla provádíte Vy a jejím cílem je poskytnutí 8 fotografií Vašeho vozidla.',
	'chooseLang.headline': 'Výběr jazyka',
	'blockedByDevice.headline': 'Tato platforma nepodporuje použití stolního počítače.',

	'blockedByDevice.description':
		'K dokumentaci Vašeho vozu budete potřebovat internetový prohlížeč.<br>Dokumentace Vašeho vozu je možná výhradně pomocí mobilního zařízení.<br>Chcete-li pokračovat, spusťte odkaz na prohlídku na mobilním zařízení.',

	'vehicleImages.overviewPhotos': 'Vozidlo',
	'vehicleImages.description':
		'Vyfoťte své vozidlo ze všech úhlů. SPZ musí být dobře viditelná a čitelná na všech 4 fotografiích.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Levý předobok',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Levý zadobok',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Pravý zadobok',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Pravý předobok',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Příklad',
	'button.next': 'Další',

	'imageRecognitionMismatchModal.headline':
		'Přesvědčte se, že jsou všechny fotografie pořízené dle instrukcí',
	'button.continue': 'POKRAČOVAT',
	'button.backchangeImage': 'POŘIĎTE FOTOGRAFII ZNOVU',

	'vehicleImages.leftFrontOverview': 'Levý předobok',
	'vehicleImages.leftRearOverview': 'Levý zadobok',
	'vehicleImages.rightRearOverview': 'Pravý zadobok',
	'vehicleImages.rightFrontOverview': 'Pravý předobok',
	'button.changeImage': 'POŘIĎTE FOTOGRAFII ZNOVU',

	'completeVehicleImagesModal.headline': 'Chybějící fotografie',
	'completeVehicleImagesModal.description': 'Prosím pořiďte následující fotografie:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Levý předobok',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Levý zadobok',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Pravý zadobok',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Pravý předobok',
	'button.ok': 'OK',

	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle': 'Levý předobok - příklad',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle': 'Levý zadobok - příklad',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle': 'Pravý zadobok - příklad',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle': 'Pravý předobok - příklad',
	'fourPerspectivesExampleModal.button.close': 'OK',

	'button.prev': 'Zpět',
	'fourAdditionalPictures.title': 'Doplňující fotografie',
	'fourAdditionalPictures.overallDashboard.title': 'Přístrojová deska vozidla',
	'fourAdditionalPictures.overallDashboard.description':
		'Vyfoťte celou rozsvícenou přístrojovou desku vozidla.',
	'fourAdditionalPictures.mileage.title': 'Stav tachometru',
	'dashboardMileage.dashboard.paragraph':
		'Vyfoťte celkový počet ujetých kilometrů. Pokud máte elektronický tachometr, před focením prosím nastartujte motor.',
	'dashboardMileage.paragraph.first': 'Zadejte počet najetých kilometrů.',
	'dashboardMileage.placeholder': 'Aktuální stav tachometru',
	'fourAdditionalPictures.windshield.title': 'Přední sklo vozidla',
	'fourAdditionalPictures.windshield.description': 'Vyfoťte prosím přední sklo vozidla.',
	'fourAdditionalPictures.vin.title': 'VIN vozidla',
	'fourAdditionalPictures.vin.description':
		'Vyfoťte prosím VIN vozidla. Naleznete ho na těsnění dveří řidiče nebo v levém dolním rohu čelního skla.',

	'imageRecognitionMistmatchModal.headline':
		'Přesvědčte se, že jsou všechny fotografie pořízené dle instrukcí',
	'completeFourAdditionalPicturesModal.headline': 'Chybějící fotografie',
	'completeFourAdditionalPicturesModal.description': 'Prosím pořiďte následující fotografie:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Přístrojová deska vozidla',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Stav tachometru',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Přední sklo vozidla',
	'completeFourAdditionalPicturesModal.hasVINImage': 'VIN vozidla',

	'fourAdditionalPictures.overallDashboard.exampleModalTitle':
		'Přístrojová deska vozidla - příklad',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Stav tachometru - příklad',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Přední sklo vozidla - příklad',
	'fourAdditionalPictures.vin.exampleModalTitle': 'VIN vozidla - příklad',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',

	'upload.message':
		'Vaše údaje se nahrávají. Při slabším internetovém připojení to může chvíli trvat. ',

	'feedback.headline.policyCheck': 'Všechny fotografie jsme v pořádku obdrželi!',
	'feedback.rating.policyCheck': 'Jak hodnotíte Vaši zkušenost?',
	'feedback.yourOpinion': 'Máte nějaké připomínky? Dejte nám prosím vědět!',

	'feedback.comment.placeholder': 'Přidejte Váš komentář',
	'feedback.button.send': 'Odeslat',

	'thanks.headline.first': 'Děkujeme za Vaši zpětnou vazbu!',
	'waitForAudit.thankYou': 'Děkujeme za Vaši zpětnou vazbu!',

	'thanks.paragraph.first': ' ',
	'waitForAudit.description.damageFound': ' ',
	'waitForAudit.description.damageNotFound': ' ',

	'timeout.bottom': 'Platnost odkazu vypršela, volejte prosím\r\n+420 241 170 000.',
	'timeout.headline.first': ' ',

	'button.reverse': 'VYFOŤTE NAJETÉ KM',
	'button.confirm': 'POTVRĎTE NAJETÉ KM',
	'mileageModal.headline': 'Prosím zkontrolujte, že údaj o počtu najetých kilometrů je správný',
	'mileageModal.paragraph':
		'Počet najetých kilometrů z fotografie se liší od toho zapsaného. Změňte hodnotu nebo potvrďte, že zapsaný údaj je správný a lze pokračovat.',
	'mileageModal.insertedMileagePlaceholder': 'Váš zápis najetých km',
	'mileageModal.pictureMileage': 'Počet kilometrů převzatý z fotografie tachometru',
	'dashboardMileage.input.error': 'Prosíme zadejte aktuální hodnotu z tachometru vozidla',
	'mismatchModal.enteredMileage': 'Stav tachometru',

	'dashboardMileage.dashboard.title': 'Stav tachometru',
	'windshieldImage.headline': 'Přední sklo vozidla',

	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',
	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',

	'invalidFile.size.title': 'Nesprávná velikost fotografie',
	'invalidFile.size.description': 'Fotografie je větší než požadovaná velikost.',
	'invalidFile.extension.title': 'Tento typ souboru není podporován',
	'invalidFile.extension.description':
		'Tento typ souboru není podporován. Podporované typy: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp.',
};

export default messages;
